import { Box, Flex, HStack, IconButton, Button, useDisclosure, Stack } from '@chakra-ui/react';
import { HamburgerIcon, CloseIcon } from '@chakra-ui/icons';
import { Link, useLocation } from 'react-router-dom';

function Navigation() {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const location = useLocation();

    // Function to determine if a link is active
    const isActive = (path) => location.pathname === path;

    return (
        <Box bg="brand.orange" px={4}>
            <Flex
                h={{ base: "auto", md: 16 }} // Adjust height: auto for mobile, fixed for desktop
                alignItems="center"
                justifyContent="space-between"
            >
                {/* Desktop Navigation */}
                <HStack
                    spacing={4}
                    alignItems="center"
                    display={{ base: 'none', md: 'flex' }} // Hide desktop nav in mobile view
                    justifyContent="space-around"
                    width="100%"
                >
                    <Link to="/">
                        <Button
                            variant="link"
                            color={isActive("/") ? "brand.blue" : "white"}
                            bg={isActive("/") ? "brand.mildOrange" : "transparent"}
                            borderRadius="md"
                            px={4}
                            py={2}
                        >
                            Home
                        </Button>
                    </Link>
                    <Link to="/forms">
                        <Button
                            variant="link"
                            color={isActive("/forms") ? "brand.blue" : "white"}
                            bg={isActive("/forms") ? "brand.mildOrange" : "transparent"}
                            borderRadius="md"
                            px={4}
                            py={2}
                        >
                            Forms & Manuals
                        </Button>
                    </Link>
                    <Link to="/office">
                        <Button
                            variant="link"
                            color={isActive("/office") ? "brand.blue" : "white"}
                            bg={isActive("/office") ? "brand.mildOrange" : "transparent"}
                            borderRadius="md"
                            px={4}
                            py={2}
                        >
                            Office Bearers
                        </Button>
                    </Link>
                    <Link to="/photos">
                        <Button
                            variant="link"
                            color={isActive("/photos") ? "brand.blue" : "white"}
                            bg={isActive("/photos") ? "brand.mildOrange" : "transparent"}
                            borderRadius="md"
                            px={4}
                            py={2}
                        >
                            Photo Gallery
                        </Button>
                    </Link>
                    <Link to="/about">
                        <Button
                            variant="link"
                            color={isActive("/about") ? "brand.blue" : "white"}
                            bg={isActive("/about") ? "brand.mildOrange" : "transparent"}
                            borderRadius="md"
                            px={4}
                            py={2}
                        >
                            About Us
                        </Button>
                    </Link>
                    <Link to="/contact">
                        <Button
                            variant="link"
                            color={isActive("/contact") ? "brand.blue" : "white"}
                            bg={isActive("/contact") ? "brand.mildOrange" : "transparent"}
                            borderRadius="md"
                            px={4}
                            py={2}
                        >
                            Contact Us
                        </Button>
                    </Link>
                </HStack>
            </Flex>

            {/* Floating Hamburger Icon */}
            <IconButton
                size="md"
                icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
                aria-label="Open Menu"
                position="absolute"
                top={1}
                right={1}
                zIndex={30}
                bg="#FF9141"
                color="white"
                display={{ md: 'none' }} // Show only in mobile view
                onClick={isOpen ? onClose : onOpen}
            />

            {/* Mobile Navigation */}
            {isOpen ? (
                <Box
                    position="absolute"
                    top={0}
                    right={0}
                    bg="#FF9141"
                    w="60%"
                    h="100vh"
                    zIndex={20}
                    p={4}
                    display={{ md: 'none' }} // Show only in mobile view
                >
                    <Stack as="nav" spacing={4}>
                        <Link to="/">
                            <Button
                                variant="link"
                                color={isActive("/") ? "brand.blue" : "white"}
                                bg={isActive("/") ? "brand.mildOrange" : "transparent"}
                                borderRadius="md"
                                px={4}
                                py={2}
                                onClick={onClose}
                            >
                                Home
                            </Button>
                        </Link>
                        <Link to="/forms">
                            <Button
                                variant="link"
                                color={isActive("/forms") ? "brand.blue" : "white"}
                                bg={isActive("/forms") ? "brand.mildOrange" : "transparent"}
                                borderRadius="md"
                                px={4}
                                py={2}
                                onClick={onClose}
                            >
                                Forms & Manuals
                            </Button>
                        </Link>
                        <Link to="/office">
                            <Button
                                variant="link"
                                color={isActive("/office") ? "brand.blue" : "white"}
                                bg={isActive("/office") ? "brand.mildOrange" : "transparent"}
                                borderRadius="md"
                                px={4}
                                py={2}
                                onClick={onClose}
                            >
                                Office Bearers
                            </Button>
                        </Link>
                        <Link to="/photos">
                            <Button
                                variant="link"
                                color={isActive("/photos") ? "brand.blue" : "white"}
                                bg={isActive("/photos") ? "brand.mildOrange" : "transparent"}
                                borderRadius="md"
                                px={4}
                                py={2}
                                onClick={onClose}
                            >
                                Photo Gallery
                            </Button>
                        </Link>
                        <Link to="/about">
                            <Button
                                variant="link"
                                color={isActive("/about") ? "brand.blue" : "white"}
                                bg={isActive("/about") ? "brand.mildOrange" : "transparent"}
                                borderRadius="md"
                                px={4}
                                py={2}
                                onClick={onClose}
                            >
                                About Us
                            </Button>
                        </Link>
                        <Link to="/contact">
                            <Button
                                variant="link"
                                color={isActive("/contact") ? "brand.blue" : "white"}
                                bg={isActive("/contact") ? "brand.mildOrange" : "transparent"}
                                borderRadius="md"
                                px={4}
                                py={2}
                                onClick={onClose}
                            >
                                Contact Us
                            </Button>
                        </Link>
                    </Stack>
                </Box>
            ) : null}
        </Box>
    );
}

export default Navigation;